import { Box } from "@mui/material";
import { UserDetail } from "./UserDetail";

export const fieldsQuery = "*.*";

export const userRoutes = [
    {
        path: "/user",
        element: (
            <Box>
                <UserDetail />
            </Box>
        ),
    },
];
